export default __webpack_public_path__ + "static/media/Trust.e3c2ec15.svg";